import DTCopyTextSendMacroView from '../../DTCopyTextSendMacroView';
import React from 'react';
import openSelectCancellationReasonPopup from '../../../../../popups/SelectCancellationReasonPopup/SelectCancellationReasonPopup';
import { useDispatch, useSelector } from 'react-redux';
import { getExtraBusinessInfoOfSelectedTicket } from '../../../../../../extractFromState';
import { withConfirmation } from '../../../../DTConfirmationView/withConfirmation';
import { processCancelSubscription } from '../../../../../../actions/tools/DecisionTree/SubscriptionActions';
import { CANCEL_SUBSCRIPTION_ERROR_MESSAGE } from '../../../../../../constants/decisionTree';

const DTSendMacroAndCancelSubscriptionNode = () => {
  const dispatch = useDispatch();
  const cancellationReasons = useSelector(getExtraBusinessInfoOfSelectedTicket).cancellationReasons || [];

  const handleNextButtonClick = async () => {
    // if selected business has predefined cancellation reasons, show dropdown before cancelling, else just cancel
    const hasCancellationReasons = !!cancellationReasons.length;
    const cancelNonShippedOrders = false;
    if (hasCancellationReasons) {
      await openSelectCancellationReasonPopup({
        onConfirm: async ({ cancellationReason, cancellationNote }) => {
          await dispatch(processCancelSubscription({ cancelNonShippedOrders, cancellationReason, cancellationNote }));
        },
      });
    } else {
      await dispatch(processCancelSubscription({ cancelNonShippedOrders }));
    }
  };

  return (
    <DTCopyTextSendMacroView
      buttonText={'CANCEL'}
      onNextButtonClick={handleNextButtonClick}
      hideCopyText={false}
      popupConfirmationText={'You are about to cancel this subscription and copy the response to the text box'}
      customErrorMessage={CANCEL_SUBSCRIPTION_ERROR_MESSAGE}
      skipExtraActions={true}
    />
  );
};

export default withConfirmation(DTSendMacroAndCancelSubscriptionNode);
